import { sortSegmentEndpoints } from "utils/math/geometry/sortSegmentEndpoints";
import type { EdgeKey, CountEdgeUsage } from "./types";

export const countEdgeUsage: CountEdgeUsage = ({ paths }) => {
  const edgeCounts = new Map<EdgeKey, number>();

  for (const path of paths) {
    for (let i = 0; i < path.length - 1; i++) {
      const idA = path[i];
      const idB = path[i + 1];

      // 2. Use the helper to create a normalized object key
      const edge = sortSegmentEndpoints({
        pointAId: idA,
        pointBId: idB,
      });

      const edgeKey: EdgeKey = `${edge.from}|${edge.to}`;

      // 3. Update the Map
      const currentCount = edgeCounts.get(edgeKey) ?? 0;
      edgeCounts.set(edgeKey, currentCount + 1);
    }
  }

  return edgeCounts;
};
